
const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default browserTimeZone;